/* shto-howto: each step's looping video loads only when it scrolls near view, plays while on screen and pauses off it.
   With reduced motion nothing loads: the still photo and poster stay. Without IntersectionObserver the videos start at once.
   Runs once per page, and picks up sections the theme editor re-renders. */
(function () {
  if (window.shtoHowtoVideos) return;
  window.shtoHowtoVideos = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
  var observer = null;

  function play(video) {
    var p = video.play();
    if (p && p.catch) p.catch(function () {});
  }

  function start(video) {
    if (video.getAttribute('data-shto-loaded')) return;
    video.setAttribute('data-shto-loaded', '1');
    video.muted = true;
    video.src = video.getAttribute('data-shto-video-src');
    play(video);
  }

  function watch(root) {
    if (reduce && reduce.matches) return;
    var videos = (root || document).querySelectorAll('[data-shto-section="shto-howto"] video[data-shto-video-src]');
    if (!videos.length) return;
    if (!('IntersectionObserver' in window)) {
      for (var i = 0; i < videos.length; i++) start(videos[i]);
      return;
    }
    if (!observer) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target;
          if (entry.isIntersecting) {
            if (video.getAttribute('data-shto-loaded')) play(video);
            else start(video);
          } else if (video.getAttribute('data-shto-loaded')) {
            video.pause();
          }
        });
      }, { rootMargin: '300px 0px' });
    }
    for (var j = 0; j < videos.length; j++) {
      if (videos[j].getAttribute('data-shto-watched')) continue;
      videos[j].setAttribute('data-shto-watched', '1');
      observer.observe(videos[j]);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { watch(); });
  else watch();
  document.addEventListener('shopify:section:load', function (event) { watch(event.target); });
})();
